module.exports = __webpack_public_path__ + "img/report-icon-active.e26d4557.svg";